import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b85b1d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "cancelSubscriptionModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "cancelSubscriptionModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Cancel Subscription", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Please enter 'cancel' to cancel your account subscription.", -1))
const _hoisted_10 = {
  key: 1,
  class: "text-dark text-success mt-3 mb-3"
}
const _hoisted_11 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  placeholder: "Enter 'cancel'",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("pre", _hoisted_10, "An error occured: " + _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger ms-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                disabled: !_ctx.name.length || _ctx.submitted || _ctx.name != 'cancel'
              }, _toDisplayString(_ctx.submitted ? "Canceling" : "Cancel"), 9, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}